import RiskLevel from '../types/RiskLevel';

/**
 * Legacy endpoint risk level storage using object literal
 * Key format: "METHOD https://server.com/path"
 *
 * NOTE (pakinepalli, 2025-09-12): I generated this with a local script.
 * We'll never add new endpoints to this because these are all legacy API site endpoints.
 * All new endpoints exposed via Try It Out will be Open Cloud endpoints.
 */
export const LEGACY_ENDPOINT_RISK_LEVELS = {
  'GET https://accountinformation.roblox.com/v1/birthdate': RiskLevel.HIGH,
  'POST https://accountinformation.roblox.com/v1/birthdate': RiskLevel.CRITICAL,
  'GET https://accountinformation.roblox.com/v1/description': RiskLevel.LOW,
  'POST https://accountinformation.roblox.com/v1/description': RiskLevel.MEDIUM,
  'POST https://accountinformation.roblox.com/v1/email/verify': RiskLevel.CRITICAL,
  'GET https://accountinformation.roblox.com/v1/gender': RiskLevel.HIGH,
  'POST https://accountinformation.roblox.com/v1/gender': RiskLevel.CRITICAL,
  'GET https://accountinformation.roblox.com/v1/metadata': RiskLevel.LOW,
  'GET https://accountinformation.roblox.com/v1/phone': RiskLevel.CRITICAL,
  'POST https://accountinformation.roblox.com/v1/phone': RiskLevel.CRITICAL,
  'POST https://accountinformation.roblox.com/v1/phone/delete': RiskLevel.CRITICAL,
  'POST https://accountinformation.roblox.com/v1/phone/resend': RiskLevel.CRITICAL,
  'POST https://accountinformation.roblox.com/v1/phone/verify': RiskLevel.CRITICAL,
  'GET https://accountinformation.roblox.com/v1/promotion-channels': RiskLevel.LOW,
  'POST https://accountinformation.roblox.com/v1/promotion-channels': RiskLevel.HIGH,
  'DELETE https://accountinformation.roblox.com/v1/star-code-affiliates': RiskLevel.CRITICAL,
  'GET https://accountinformation.roblox.com/v1/star-code-affiliates': RiskLevel.HIGH,
  'POST https://accountinformation.roblox.com/v1/star-code-affiliates': RiskLevel.CRITICAL,
  'GET https://accountinformation.roblox.com/v1/users/{userId}/promotion-channels': RiskLevel.LOW,
  'GET https://accountinformation.roblox.com/v1/users/{userId}/roblox-badges': RiskLevel.LOW,
  'GET https://accountinformation.roblox.com/v1/xbox-live/consecutive-login-days': RiskLevel.MEDIUM,
  'GET https://accountsettings.roblox.com/v1/account/settings/account-country': RiskLevel.CRITICAL,
  'POST https://accountsettings.roblox.com/v1/account/settings/account-country': RiskLevel.CRITICAL,
  'GET https://accountsettings.roblox.com/v1/account/settings/metadata': RiskLevel.MEDIUM,
  'GET https://accountsettings.roblox.com/v1/email': RiskLevel.CRITICAL,
  'PATCH https://accountsettings.roblox.com/v1/email': RiskLevel.CRITICAL,
  'POST https://accountsettings.roblox.com/v1/email': RiskLevel.CRITICAL,
  'POST https://accountsettings.roblox.com/v1/email/verify': RiskLevel.CRITICAL,
  'GET https://accountsettings.roblox.com/v1/themes/{consumerType}/{consumerId}': RiskLevel.LOW,
  'PATCH https://accountsettings.roblox.com/v1/themes/{consumerType}/{consumerId}': RiskLevel.LOW,
  'GET https://accountsettings.roblox.com/v1/themes/types': RiskLevel.LOW,
  'GET https://accountsettings.roblox.com/v1/trade-privacy': RiskLevel.CRITICAL,
  'POST https://accountsettings.roblox.com/v1/trade-privacy': RiskLevel.CRITICAL,
  'GET https://accountsettings.roblox.com/v1/trade-value': RiskLevel.CRITICAL,
  'POST https://accountsettings.roblox.com/v1/trade-value': RiskLevel.CRITICAL,
  'GET https://adconfiguration.roblox.com/v2/sponsored-campaigns': RiskLevel.MEDIUM,
  'POST https://adconfiguration.roblox.com/v2/sponsored-campaigns/create': RiskLevel.HIGH,
  'GET https://adconfiguration.roblox.com/v2/sponsored-campaigns/eligible-asset-type-ids':
    RiskLevel.LOW,
  'POST https://adconfiguration.roblox.com/v2/sponsored-campaigns/eligible-campaign-targets':
    RiskLevel.MEDIUM,
  'GET https://adconfiguration.roblox.com/v2/sponsored-campaigns/multi-get-can-user-sponsor':
    RiskLevel.MEDIUM,
  'POST https://adconfiguration.roblox.com/v2/sponsored-campaigns/stop': RiskLevel.HIGH,
  'GET https://adconfiguration.roblox.com/v2/sponsored-games': RiskLevel.MEDIUM,
  'POST https://adconfiguration.roblox.com/v2/sponsored-games/create': RiskLevel.HIGH,
  'POST https://adconfiguration.roblox.com/v2/sponsored-games/stop': RiskLevel.HIGH,
  'GET https://adconfiguration.roblox.com/v2/sponsored-games/universes': RiskLevel.MEDIUM,
  'GET https://assetdelivery.roblox.com/v1/alias/{alias}': RiskLevel.LOW,
  'GET https://assetdelivery.roblox.com/v1/asset': RiskLevel.LOW,
  'GET https://assetdelivery.roblox.com/v1/assetId/{assetId}': RiskLevel.LOW,
  'GET https://assetdelivery.roblox.com/v1/assetId/{assetId}/version/{versionNumber}':
    RiskLevel.LOW,
  'POST https://assetdelivery.roblox.com/v1/assets/batch': RiskLevel.LOW,
  'GET https://assetdelivery.roblox.com/v1/marAssetHash/{marAssetHash}/marCheckSum/{marCheckSum}':
    RiskLevel.LOW,
  'GET https://assetdelivery.roblox.com/v2/alias/{alias}': RiskLevel.LOW,
  'GET https://assetdelivery.roblox.com/v2/asset': RiskLevel.LOW,
  'GET https://assetdelivery.roblox.com/v2/assetId/{assetId}': RiskLevel.LOW,
  'GET https://assetdelivery.roblox.com/v2/assetId/{assetId}/version/{versionNumber}':
    RiskLevel.LOW,
  'POST https://assetdelivery.roblox.com/v2/assets/batch': RiskLevel.LOW,
  'GET https://assetdelivery.roblox.com/v2/marAssetHash/{marAssetHash}/marCheckSum/{marCheckSum}':
    RiskLevel.LOW,
  'DELETE https://auth.roblox.com/v1/account/pin': RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v1/account/pin': RiskLevel.HIGH,
  'PATCH https://auth.roblox.com/v1/account/pin': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/account/pin': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/account/pin/lock': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/account/pin/unlock': RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v1/auth/metadata': RiskLevel.HIGH,
  'GET https://auth.roblox.com/v1/client-assertion': RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v1/external/{identityProviderId}/sso/oauth/callback':
    RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v1/external/{identityProviderId}/sso/oauth/init': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/external/access': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/external/login': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/external/loginAndLink': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/external/signup': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/external/unlink': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/identity-verification/login': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/identity/initialize-login': RiskLevel.HIGH,
  'POST https://auth.roblox.com/v1/login': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/login/linked': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/logout': RiskLevel.HIGH,
  'POST https://auth.roblox.com/v1/logoutfromallsessionsandreauthenticate': RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v1/metadata': RiskLevel.HIGH,
  'POST https://auth.roblox.com/v1/passkey/DeleteCredentialBatch': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/passkey/finish-preauth-registration': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/passkey/FinishRegistration': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/passkey/ListCredentials': RiskLevel.HIGH,
  'POST https://auth.roblox.com/v1/passkey/start-authentication-by-user': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/passkey/start-preauth-registration': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/passkey/StartAuthentication': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/passkey/StartRegistration': RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v1/passwords/validate': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/passwords/validate': RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v1/recovery/metadata': RiskLevel.HIGH,
  'GET https://auth.roblox.com/v1/revert/account': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/revert/account': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/session/refresh': RiskLevel.HIGH,
  'POST https://auth.roblox.com/v1/signup': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/signup/linked': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/social/{provider}/disconnect': RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v1/social/connected-providers': RiskLevel.HIGH,
  'POST https://auth.roblox.com/v1/user/passwords/change': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v1/username': RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v1/usernames': RiskLevel.MEDIUM,
  'POST https://auth.roblox.com/v1/usernames/recover': RiskLevel.HIGH,
  'GET https://auth.roblox.com/v1/usernames/validate': RiskLevel.LOW,
  'POST https://auth.roblox.com/v1/usernames/validate': RiskLevel.LOW,
  'GET https://auth.roblox.com/v1/validators/email': RiskLevel.MEDIUM,
  'GET https://auth.roblox.com/v1/validators/recommendedUsernameFromDisplayName': RiskLevel.LOW,
  'POST https://auth.roblox.com/v1/validators/recommendedUsernameFromDisplayName': RiskLevel.LOW,
  'GET https://auth.roblox.com/v1/validators/username': RiskLevel.LOW,
  'POST https://auth.roblox.com/v1/validators/username': RiskLevel.LOW,
  'GET https://auth.roblox.com/v1/xbox/connection': RiskLevel.HIGH,
  'POST https://auth.roblox.com/v1/xbox/disconnect': RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v1/xbox/get-login-consecutive-days': RiskLevel.MEDIUM,
  'POST https://auth.roblox.com/v1/xbox/translate': RiskLevel.HIGH,
  'GET https://auth.roblox.com/v2/auth/metadata': RiskLevel.HIGH,
  'POST https://auth.roblox.com/v2/identity-verification/login': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v2/login': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v2/login/linked': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v2/logout': RiskLevel.HIGH,
  'POST https://auth.roblox.com/v2/logoutfromallsessionsandreauthenticate': RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v2/metadata': RiskLevel.HIGH,
  'GET https://auth.roblox.com/v2/passwords/current-status': RiskLevel.HIGH,
  'GET https://auth.roblox.com/v2/passwords/reset': RiskLevel.HIGH,
  'POST https://auth.roblox.com/v2/passwords/reset': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v2/passwords/reset/send': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v2/passwords/reset/verify': RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v2/passwords/validate': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v2/passwords/validate': RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v2/recovery/metadata': RiskLevel.HIGH,
  'GET https://auth.roblox.com/v2/revert/account': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v2/revert/account': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v2/session/refresh': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v2/signup': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v2/signup/linked': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v2/user/passwords/change': RiskLevel.CRITICAL,
  'POST https://auth.roblox.com/v2/username': RiskLevel.CRITICAL,
  'GET https://auth.roblox.com/v2/usernames': RiskLevel.MEDIUM,
  'POST https://auth.roblox.com/v2/usernames/recover': RiskLevel.HIGH,
  'GET https://auth.roblox.com/v2/usernames/validate': RiskLevel.LOW,
  'POST https://auth.roblox.com/v2/usernames/validate': RiskLevel.LOW,
  'POST https://auth.roblox.com/v3/logout': RiskLevel.HIGH,
  'POST https://auth.roblox.com/v3/users/{userId}/two-step-verification/login': RiskLevel.CRITICAL,
  'GET https://avatar.roblox.com/v1/avatar': RiskLevel.LOW,
  'GET https://avatar.roblox.com/v1/avatar-rules': RiskLevel.LOW,
  'GET https://avatar.roblox.com/v1/avatar/metadata': RiskLevel.LOW,
  'POST https://avatar.roblox.com/v1/avatar/redraw-thumbnail': RiskLevel.LOW,
  'POST https://avatar.roblox.com/v1/avatar/set-body-colors': RiskLevel.MEDIUM,
  'POST https://avatar.roblox.com/v1/avatar/set-player-avatar-type': RiskLevel.MEDIUM,
  'POST https://avatar.roblox.com/v1/avatar/set-scales': RiskLevel.MEDIUM,
  'POST https://avatar.roblox.com/v1/avatar/set-wearing-assets': RiskLevel.MEDIUM,
  'GET https://avatar.roblox.com/v1/game-start-info': RiskLevel.LOW,
  'POST https://avatar.roblox.com/v1/outfits/{userOutfitId}/delete': RiskLevel.HIGH,
  'GET https://avatar.roblox.com/v1/outfits/{userOutfitId}/details': RiskLevel.LOW,
  'GET https://avatar.roblox.com/v1/users/{userId}/avatar': RiskLevel.LOW,
  'GET https://avatar.roblox.com/v1/users/{userId}/currently-wearing': RiskLevel.LOW,
  'GET https://avatar.roblox.com/v1/users/{userId}/outfits': RiskLevel.MEDIUM,
  'GET https://avatar.roblox.com/v2/avatar/avatar': RiskLevel.LOW,
  'POST https://avatar.roblox.com/v2/avatar/set-body-colors': RiskLevel.MEDIUM,
  'POST https://avatar.roblox.com/v2/avatar/set-wearing-assets': RiskLevel.MEDIUM,
  'GET https://avatar.roblox.com/v2/avatar/users/{userId}/avatar': RiskLevel.LOW,
  'GET https://avatar.roblox.com/v2/avatar/users/{userId}/outfits': RiskLevel.MEDIUM,
  'PATCH https://avatar.roblox.com/v2/outfits/{userOutfitId}': RiskLevel.MEDIUM,
  'POST https://avatar.roblox.com/v2/outfits/{userOutfitId}/update': RiskLevel.MEDIUM,
  'POST https://avatar.roblox.com/v2/outfits/create': RiskLevel.MEDIUM,
  'PATCH https://avatar.roblox.com/v3/outfits/{userOutfitId}': RiskLevel.MEDIUM,
  'GET https://avatar.roblox.com/v3/outfits/{userOutfitId}/details': RiskLevel.LOW,
  'POST https://avatar.roblox.com/v3/outfits/create': RiskLevel.MEDIUM,
  'GET https://badges.roblox.com/v1/badges/{badgeId}': RiskLevel.LOW,
  'PATCH https://badges.roblox.com/v1/badges/{badgeId}': RiskLevel.MEDIUM,
  'POST https://badges.roblox.com/v1/badges/{badgeId}/icon': RiskLevel.MEDIUM,
  'GET https://badges.roblox.com/v1/badges/metadata': RiskLevel.LOW,
  'GET https://badges.roblox.com/v1/universes/{universeId}/badges': RiskLevel.LOW,
  'POST https://badges.roblox.com/v1/universes/{universeId}/badges': RiskLevel.MEDIUM,
  'GET https://badges.roblox.com/v1/universes/{universeId}/free-badges-quota': RiskLevel.LOW,
  'DELETE https://badges.roblox.com/v1/user/{userId}/badges/{badgeId}': RiskLevel.CRITICAL,
  'DELETE https://badges.roblox.com/v1/user/badges/{badgeId}': RiskLevel.HIGH,
  'GET https://badges.roblox.com/v1/users/{userId}/badges': RiskLevel.LOW,
  'GET https://badges.roblox.com/v1/users/{userId}/badges/{badgeId}/awarded-date': RiskLevel.LOW,
  'GET https://badges.roblox.com/v1/users/{userId}/badges/awarded-dates': RiskLevel.LOW,
  'GET https://catalog.roblox.com/v1/asset-to-category': RiskLevel.LOW,
  'GET https://catalog.roblox.com/v1/asset-to-subcategory': RiskLevel.LOW,
  'GET https://catalog.roblox.com/v1/assets/{assetId}/bundles': RiskLevel.LOW,
  'GET https://catalog.roblox.com/v1/bundles/{bundleId}/details': RiskLevel.LOW,
  'GET https://catalog.roblox.com/v1/bundles/{bundleId}/recommendations': RiskLevel.LOW,
  'GET https://catalog.roblox.com/v1/bundles/details': RiskLevel.LOW,
  'POST https://catalog.roblox.com/v1/catalog/items/details': RiskLevel.LOW,
  'GET https://catalog.roblox.com/v1/categories': RiskLevel.LOW,
  'GET https://catalog.roblox.com/v1/favorites/assets/{assetId}/count': RiskLevel.LOW,
  'GET https://catalog.roblox.com/v1/favorites/bundles/{bundleId}/count': RiskLevel.LOW,
  'DELETE https://catalog.roblox.com/v1/favorites/users/{userId}/assets/{assetId}/favorite':
    RiskLevel.MEDIUM,
  'GET https://catalog.roblox.com/v1/favorites/users/{userId}/assets/{assetId}/favorite':
    RiskLevel.MEDIUM,
  'POST https://catalog.roblox.com/v1/favorites/users/{userId}/assets/{assetId}/favorite':
    RiskLevel.MEDIUM,
  'DELETE https://catalog.roblox.com/v1/favorites/users/{userId}/bundles/{bundleId}/favorite':
    RiskLevel.MEDIUM,
  'GET https://catalog.roblox.com/v1/favorites/users/{userId}/bundles/{bundleId}/favorite':
    RiskLevel.MEDIUM,
  'POST https://catalog.roblox.com/v1/favorites/users/{userId}/bundles/{bundleId}/favorite':
    RiskLevel.MEDIUM,
  'GET https://catalog.roblox.com/v1/favorites/users/{userId}/favorites/{assetTypeId}/assets':
    RiskLevel.LOW,
  'GET https://catalog.roblox.com/v1/favorites/users/{userId}/favorites/{subtypeId}/bundles':
    RiskLevel.LOW,
  'GET https://catalog.roblox.com/v1/subcategories': RiskLevel.LOW,
  'POST https://catalog.roblox.com/v1/topic/get-topics': RiskLevel.LOW,
  'GET https://catalog.roblox.com/v1/users/{userId}/bundles': RiskLevel.LOW,
  'GET https://catalog.roblox.com/v1/users/{userId}/bundles/{bundleType}': RiskLevel.LOW,
  'GET https://catalog.roblox.com/v2/search/items/details': RiskLevel.LOW,
  'GET https://clientsettings.roblox.com/v1/client-version/{binaryType}': RiskLevel.LOW,
  'GET https://clientsettings.roblox.com/v1/installer-cdns': RiskLevel.LOW,
  'GET https://clientsettings.roblox.com/v1/mobile-client-version': RiskLevel.LOW,
  'GET https://clientsettings.roblox.com/v2/client-version/{binaryType}': RiskLevel.LOW,
  'GET https://clientsettings.roblox.com/v2/client-version/{binaryType}/channel/{channelName}':
    RiskLevel.LOW,
  'GET https://clientsettings.roblox.com/v2/compression-dictionaries': RiskLevel.LOW,
  'GET https://clientsettings.roblox.com/v2/compression-dictionaries/{dictionarySha256}':
    RiskLevel.LOW,
  'GET https://clientsettings.roblox.com/v2/ota-version/{binaryType}': RiskLevel.LOW,
  'GET https://clientsettings.roblox.com/v2/user-channel': RiskLevel.MEDIUM,
  'GET https://contacts.roblox.com/v1/contacts/metadata': RiskLevel.LOW,
  'POST https://contacts.roblox.com/v1/user/get-tags': RiskLevel.HIGH,
  'POST https://contacts.roblox.com/v1/user/tag': RiskLevel.HIGH,
  'GET https://contacts.roblox.com/v1/user/tag/validate': RiskLevel.LOW,
  'GET https://develop.roblox.com/v1/assets/voting': RiskLevel.LOW,
  'GET https://develop.roblox.com/v1/gametemplates': RiskLevel.LOW,
  'GET https://develop.roblox.com/v1/groups/{groupId}/universes': RiskLevel.MEDIUM,
  'PATCH https://develop.roblox.com/v1/places/{placeId}': RiskLevel.MEDIUM,
  'POST https://develop.roblox.com/v1/places/{placeId}': RiskLevel.MEDIUM,
  'GET https://develop.roblox.com/v1/places/{placeId}/teamcreate/active_session/members':
    RiskLevel.MEDIUM,
  'GET https://develop.roblox.com/v1/plugins': RiskLevel.LOW,
  'PATCH https://develop.roblox.com/v1/plugins/{pluginId}': RiskLevel.MEDIUM,
  'GET https://develop.roblox.com/v1/universes/{universeId}': RiskLevel.LOW,
  'POST https://develop.roblox.com/v1/universes/{universeId}/activate': RiskLevel.HIGH,
  'GET https://develop.roblox.com/v1/universes/{universeId}/configuration': RiskLevel.MEDIUM,
  'PATCH https://develop.roblox.com/v1/universes/{universeId}/configuration': RiskLevel.HIGH,
  'GET https://develop.roblox.com/v1/universes/{universeId}/configuration/vip-servers':
    RiskLevel.MEDIUM,
  'POST https://develop.roblox.com/v1/universes/{universeId}/deactivate': RiskLevel.HIGH,
  'GET https://develop.roblox.com/v1/universes/{universeId}/permissions': RiskLevel.MEDIUM,
  'GET https://develop.roblox.com/v1/universes/{universeId}/places': RiskLevel.LOW,
  'GET https://develop.roblox.com/v1/universes/{universeId}/teamcreate': RiskLevel.MEDIUM,
  'PATCH https://develop.roblox.com/v1/universes/{universeId}/teamcreate': RiskLevel.MEDIUM,
  'DELETE https://develop.roblox.com/v1/universes/{universeId}/teamcreate/memberships':
    RiskLevel.HIGH,
  'GET https://develop.roblox.com/v1/universes/multiget': RiskLevel.LOW,
  'GET https://develop.roblox.com/v1/universes/multiget/permissions': RiskLevel.MEDIUM,
  'GET https://develop.roblox.com/v1/universes/multiget/teamcreate': RiskLevel.MEDIUM,
  'GET https://develop.roblox.com/v1/user/groups/canmanage': RiskLevel.MEDIUM,
  'GET https://develop.roblox.com/v1/user/groups/canmanagegamesoritems': RiskLevel.MEDIUM,
  'GET https://develop.roblox.com/v1/user/universes': RiskLevel.MEDIUM,
  'GET https://develop.roblox.com/v2/assets/{id}/versions': RiskLevel.MEDIUM,
  'GET https://develop.roblox.com/v2/places/{placeId}': RiskLevel.MEDIUM,
  'PATCH https://develop.roblox.com/v2/places/{placeId}': RiskLevel.MEDIUM,
  'DELETE https://develop.roblox.com/v2/teamtest/{placeId}': RiskLevel.HIGH,
  'PATCH https://develop.roblox.com/v2/universes/{universeId}/configuration': RiskLevel.MEDIUM,
  'GET https://economy.roblox.com/v1/user/currency': RiskLevel.MEDIUM,
  'GET https://economycreatorstats.roblox.com/v1/universes/{universeId}/stats': RiskLevel.MEDIUM,
  'GET https://engagementpayouts.roblox.com/v1/universe-payout-history': RiskLevel.MEDIUM,
  'GET https://followings.roblox.com/v1/users/{userId}/universes': RiskLevel.MEDIUM,
  'DELETE https://followings.roblox.com/v1/users/{userId}/universes/{universeId}': RiskLevel.MEDIUM,
  'POST https://followings.roblox.com/v1/users/{userId}/universes/{universeId}': RiskLevel.MEDIUM,
  'GET https://followings.roblox.com/v1/users/{userId}/universes/{universeId}/status':
    RiskLevel.MEDIUM,
  'GET https://followings.roblox.com/v2/users/{userId}/universes': RiskLevel.MEDIUM,
  'POST https://friends.roblox.com/v1/contacts/{targetContactId}/request-friendship':
    RiskLevel.HIGH,
  'GET https://friends.roblox.com/v1/metadata': RiskLevel.LOW,
  'GET https://friends.roblox.com/v1/my/friends/count': RiskLevel.LOW,
  'POST https://friends.roblox.com/v1/my/friends/refresh-qr-session': RiskLevel.HIGH,
  'GET https://friends.roblox.com/v1/my/friends/requests': RiskLevel.MEDIUM,
  'DELETE https://friends.roblox.com/v1/my/new-friend-requests': RiskLevel.MEDIUM,
  'GET https://friends.roblox.com/v1/my/new-friend-requests/count': RiskLevel.MEDIUM,
  'GET https://friends.roblox.com/v1/my/trusted-friends/{userId}/status': RiskLevel.MEDIUM,
  'POST https://friends.roblox.com/v1/user/{userId}/multiget-are-friends': RiskLevel.MEDIUM,
  'GET https://friends.roblox.com/v1/user/{userId}/multiget-are-trusted-friends': RiskLevel.MEDIUM,
  'POST https://friends.roblox.com/v1/user/following-exists': RiskLevel.LOW,
  'GET https://friends.roblox.com/v1/user/friend-requests/count': RiskLevel.MEDIUM,
  'POST https://friends.roblox.com/v1/user/friend-requests/decline-all': RiskLevel.HIGH,
  'POST https://friends.roblox.com/v1/users/{requesterUserId}/accept-friend-request':
    RiskLevel.HIGH,
  'POST https://friends.roblox.com/v1/users/{requesterUserId}/accept-trusted-friend-request':
    RiskLevel.CRITICAL,
  'POST https://friends.roblox.com/v1/users/{requesterUserId}/decline-friend-request':
    RiskLevel.HIGH,
  'POST https://friends.roblox.com/v1/users/{requesterUserId}/ignore-trusted-friend-request':
    RiskLevel.HIGH,
  'POST https://friends.roblox.com/v1/users/{senderUserId}/accept-friend-request-with-token':
    RiskLevel.HIGH,
  'POST https://friends.roblox.com/v1/users/{targetUserId}/follow': RiskLevel.MEDIUM,
  'GET https://friends.roblox.com/v1/users/{targetUserId}/followers': RiskLevel.LOW,
  'GET https://friends.roblox.com/v1/users/{targetUserId}/followers/count': RiskLevel.LOW,
  'GET https://friends.roblox.com/v1/users/{targetUserId}/followings': RiskLevel.LOW,
  'GET https://friends.roblox.com/v1/users/{targetUserId}/followings/count': RiskLevel.LOW,
  'POST https://friends.roblox.com/v1/users/{targetUserId}/remove-trusted-friend': RiskLevel.HIGH,
  'POST https://friends.roblox.com/v1/users/{targetUserId}/request-friendship': RiskLevel.HIGH,
  'POST https://friends.roblox.com/v1/users/{targetUserId}/send-trusted-friend-request':
    RiskLevel.CRITICAL,
  'POST https://friends.roblox.com/v1/users/{targetUserId}/unfollow': RiskLevel.MEDIUM,
  'POST https://friends.roblox.com/v1/users/{targetUserId}/unfriend': RiskLevel.HIGH,
  'GET https://friends.roblox.com/v1/users/{userId}/friends': RiskLevel.MEDIUM,
  'GET https://friends.roblox.com/v1/users/{userId}/friends/count': RiskLevel.LOW,
  'GET https://friends.roblox.com/v1/users/{userId}/friends/find': RiskLevel.MEDIUM,
  'GET https://friends.roblox.com/v1/users/{userId}/friends/inactive': RiskLevel.MEDIUM,
  'GET https://friends.roblox.com/v1/users/{userId}/friends/online': RiskLevel.MEDIUM,
  'GET https://friends.roblox.com/v1/users/{userId}/friends/search': RiskLevel.MEDIUM,
  'GET https://friends.roblox.com/v1/users/{userId}/friends/statuses': RiskLevel.MEDIUM,
  'PATCH https://gameinternationalization.roblox.com/v1/autolocalization/games/{gameId}/autolocalizationtable':
    RiskLevel.HIGH,
  'POST https://gameinternationalization.roblox.com/v1/autolocalization/games/{gameId}/autolocalizationtable':
    RiskLevel.MEDIUM,
  'PATCH https://gameinternationalization.roblox.com/v1/autolocalization/games/{gameId}/settings':
    RiskLevel.MEDIUM,
  'GET https://gameinternationalization.roblox.com/v1/autolocalization/metadata': RiskLevel.LOW,
  'GET https://gameinternationalization.roblox.com/v1/automatic-translation/games/{gameId}/feature-status':
    RiskLevel.MEDIUM,
  'GET https://gameinternationalization.roblox.com/v1/automatic-translation/games/{gameId}/quota':
    RiskLevel.MEDIUM,
  'GET https://gameinternationalization.roblox.com/v1/automatic-translation/languages/{languageCode}/target-languages':
    RiskLevel.LOW,
  'PATCH https://gameinternationalization.roblox.com/v1/badges/{badgeId}/description/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'GET https://gameinternationalization.roblox.com/v1/badges/{badgeId}/icons': RiskLevel.MEDIUM,
  'DELETE https://gameinternationalization.roblox.com/v1/badges/{badgeId}/icons/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'POST https://gameinternationalization.roblox.com/v1/badges/{badgeId}/icons/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'GET https://gameinternationalization.roblox.com/v1/badges/{badgeId}/name-description':
    RiskLevel.MEDIUM,
  'DELETE https://gameinternationalization.roblox.com/v1/badges/{badgeId}/name-description/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'PATCH https://gameinternationalization.roblox.com/v1/badges/{badgeId}/name-description/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'PATCH https://gameinternationalization.roblox.com/v1/badges/{badgeId}/name/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'PATCH https://gameinternationalization.roblox.com/v1/developer-products/{developerProductId}/description/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'GET https://gameinternationalization.roblox.com/v1/developer-products/{developerProductId}/icons':
    RiskLevel.MEDIUM,
  'DELETE https://gameinternationalization.roblox.com/v1/developer-products/{developerProductId}/icons/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'POST https://gameinternationalization.roblox.com/v1/developer-products/{developerProductId}/icons/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'GET https://gameinternationalization.roblox.com/v1/developer-products/{developerProductId}/name-description':
    RiskLevel.MEDIUM,
  'DELETE https://gameinternationalization.roblox.com/v1/developer-products/{developerProductId}/name-description/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'PATCH https://gameinternationalization.roblox.com/v1/developer-products/{developerProductId}/name-description/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'PATCH https://gameinternationalization.roblox.com/v1/developer-products/{developerProductId}/name/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'GET https://gameinternationalization.roblox.com/v1/game-icon/games/{gameId}': RiskLevel.MEDIUM,
  'DELETE https://gameinternationalization.roblox.com/v1/game-icon/games/{gameId}/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'POST https://gameinternationalization.roblox.com/v1/game-icon/games/{gameId}/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'GET https://gameinternationalization.roblox.com/v1/game-localization-status/{gameId}/translation-counts':
    RiskLevel.MEDIUM,
  'GET https://gameinternationalization.roblox.com/v1/game-localization-status/translation-counts-for-language-or-locale':
    RiskLevel.MEDIUM,
  'PATCH https://gameinternationalization.roblox.com/v1/game-passes/{gamePassId}/description/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'GET https://gameinternationalization.roblox.com/v1/game-passes/{gamePassId}/icons':
    RiskLevel.MEDIUM,
  'DELETE https://gameinternationalization.roblox.com/v1/game-passes/{gamePassId}/icons/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'POST https://gameinternationalization.roblox.com/v1/game-passes/{gamePassId}/icons/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'GET https://gameinternationalization.roblox.com/v1/game-passes/{gamePassId}/name-description':
    RiskLevel.MEDIUM,
  'DELETE https://gameinternationalization.roblox.com/v1/game-passes/{gamePassId}/name-description/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'PATCH https://gameinternationalization.roblox.com/v1/game-passes/{gamePassId}/name-description/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'PATCH https://gameinternationalization.roblox.com/v1/game-passes/{gamePassId}/name/language-codes/{languageCode}':
    RiskLevel.HIGH,
  'GET https://gameinternationalization.roblox.com/v1/game-thumbnails/games/{gameId}/images':
    RiskLevel.LOW,
  'POST https://gameinternationalization.roblox.com/v1/game-thumbnails/games/{gameId}/language-codes/{languageCode}/alt-text':
    RiskLevel.HIGH,
  'POST https://gameinternationalization.roblox.com/v1/game-thumbnails/games/{gameId}/language-codes/{languageCode}/image':
    RiskLevel.HIGH,
  'DELETE https://gameinternationalization.roblox.com/v1/game-thumbnails/games/{gameId}/language-codes/{languageCode}/images/{imageId}':
    RiskLevel.HIGH,
  'POST https://gameinternationalization.roblox.com/v1/game-thumbnails/games/{gameId}/language-codes/{languageCode}/images/order':
    RiskLevel.HIGH,
  'PATCH https://gameinternationalization.roblox.com/v1/localizationtable/gametables/{gameId}':
    RiskLevel.HIGH,
  'GET https://gameinternationalization.roblox.com/v1/name-description/games/{gameId}':
    RiskLevel.LOW,
  'PATCH https://gameinternationalization.roblox.com/v1/name-description/games/{gameId}':
    RiskLevel.HIGH,
  'POST https://gameinternationalization.roblox.com/v1/name-description/games/{gameId}/history':
    RiskLevel.MEDIUM,
  'POST https://gameinternationalization.roblox.com/v1/name-description/games/translation-history':
    RiskLevel.MEDIUM,
  'GET https://gameinternationalization.roblox.com/v1/name-description/metadata': RiskLevel.LOW,
  'GET https://gameinternationalization.roblox.com/v1/source-language/games/{gameId}':
    RiskLevel.LOW,
  'PATCH https://gameinternationalization.roblox.com/v1/source-language/games/{gameId}':
    RiskLevel.HIGH,
  'GET https://gameinternationalization.roblox.com/v1/supported-languages/games/{gameId}':
    RiskLevel.LOW,
  'PATCH https://gameinternationalization.roblox.com/v1/supported-languages/games/{gameId}':
    RiskLevel.HIGH,
  'GET https://gameinternationalization.roblox.com/v1/supported-languages/games/{gameId}/automatic-translation-status':
    RiskLevel.MEDIUM,
  'GET https://gameinternationalization.roblox.com/v1/supported-languages/games/{gameId}/in-experience-language-selection':
    RiskLevel.MEDIUM,
  'PATCH https://gameinternationalization.roblox.com/v1/supported-languages/games/{gameId}/languages/{languageCode}/automatic-translation-status':
    RiskLevel.HIGH,
  'PATCH https://gameinternationalization.roblox.com/v1/supported-languages/games/{gameId}/languages/{languageCode}/universe-display-info-automatic-translation-settings':
    RiskLevel.HIGH,
  'GET https://gameinternationalization.roblox.com/v1/supported-languages/games/{gameId}/universe-display-info-automatic-translation-settings':
    RiskLevel.MEDIUM,
  'GET https://gameinternationalization.roblox.com/v1/supported-languages/metadata': RiskLevel.LOW,
  'GET https://gameinternationalization.roblox.com/v1/translation-analytics/games/{gameId}/download-translation-analytics-report':
    RiskLevel.MEDIUM,
  'POST https://gameinternationalization.roblox.com/v1/translation-analytics/games/{gameId}/request-translation-analytics-report':
    RiskLevel.MEDIUM,
  'GET https://gameinternationalization.roblox.com/v1/translation-analytics/metadata':
    RiskLevel.LOW,
  'GET https://gameinternationalization.roblox.com/v1/ui-configurations': RiskLevel.LOW,
  'GET https://gameinternationalization.roblox.com/v1/user-localization-settings/universe/{universeId}':
    RiskLevel.MEDIUM,
  'POST https://gameinternationalization.roblox.com/v1/user-localization-settings/universe/{universeId}':
    RiskLevel.MEDIUM,
  'GET https://gameinternationalization.roblox.com/v2/supported-languages/games/{gameId}':
    RiskLevel.LOW,
  'POST https://gamejoin.roblox.com/v1/join-game': RiskLevel.CRITICAL,
  'POST https://gamejoin.roblox.com/v1/join-game-instance': RiskLevel.CRITICAL,
  'POST https://gamejoin.roblox.com/v1/join-play-together-game': RiskLevel.CRITICAL,
  'POST https://gamejoin.roblox.com/v1/join-private-game': RiskLevel.CRITICAL,
  'POST https://gamejoin.roblox.com/v1/join-reserved-game': RiskLevel.CRITICAL,
  'GET https://gamejoin.roblox.com/v1/join-team-test': RiskLevel.CRITICAL,
  'POST https://gamejoin.roblox.com/v1/play-with-user': RiskLevel.CRITICAL,
  'POST https://gamejoin.roblox.com/v1/team-create': RiskLevel.CRITICAL,
  'POST https://gamejoin.roblox.com/v1/team-create-preemptive': RiskLevel.CRITICAL,
  'GET https://games.roblox.com/v1/games': RiskLevel.LOW,
  'GET https://games.roblox.com/v1/games/{placeId}/private-servers': RiskLevel.MEDIUM,
  'GET https://games.roblox.com/v1/games/{placeId}/servers/{serverType}': RiskLevel.MEDIUM,
  'GET https://games.roblox.com/v1/games/{universeId}/favorites': RiskLevel.MEDIUM,
  'POST https://games.roblox.com/v1/games/{universeId}/favorites': RiskLevel.HIGH,
  'GET https://games.roblox.com/v1/games/{universeId}/favorites/count': RiskLevel.LOW,
  'GET https://games.roblox.com/v1/games/{universeId}/game-passes': RiskLevel.MEDIUM,
  'GET https://games.roblox.com/v1/games/{universeId}/media': RiskLevel.LOW,
  'PATCH https://games.roblox.com/v1/games/{universeId}/user-votes': RiskLevel.HIGH,
  'GET https://games.roblox.com/v1/games/{universeId}/votes': RiskLevel.LOW,
  'GET https://games.roblox.com/v1/games/{universeId}/votes/user': RiskLevel.MEDIUM,
  'GET https://games.roblox.com/v1/games/games-product-info': RiskLevel.MEDIUM,
  'GET https://games.roblox.com/v1/games/multiget-place-details': RiskLevel.LOW,
  'GET https://games.roblox.com/v1/games/multiget-playability-status': RiskLevel.HIGH,
  'GET https://games.roblox.com/v1/games/recommendations/game/{universeId}': RiskLevel.LOW,
  'POST https://games.roblox.com/v1/games/vip-servers/{universeId}': RiskLevel.HIGH,
  'GET https://games.roblox.com/v1/games/votes': RiskLevel.LOW,
  'GET https://games.roblox.com/v1/private-servers': RiskLevel.MEDIUM,
  'GET https://games.roblox.com/v1/private-servers/enabled-in-universe/{universeId}':
    RiskLevel.MEDIUM,
  'GET https://games.roblox.com/v1/private-servers/my-private-servers': RiskLevel.MEDIUM,
  'GET https://games.roblox.com/v1/vip-server/can-invite/{userId}': RiskLevel.MEDIUM,
  'GET https://games.roblox.com/v1/vip-servers/{id}': RiskLevel.MEDIUM,
  'PATCH https://games.roblox.com/v1/vip-servers/{id}': RiskLevel.HIGH,
  'PATCH https://games.roblox.com/v1/vip-servers/{id}/permissions': RiskLevel.HIGH,
  'PATCH https://games.roblox.com/v1/vip-servers/{id}/subscription': RiskLevel.HIGH,
  'PATCH https://games.roblox.com/v1/vip-servers/{id}/voicesettings': RiskLevel.HIGH,
  'GET https://games.roblox.com/v2/games/{universeId}/media': RiskLevel.LOW,
  'GET https://games.roblox.com/v2/groups/{groupId}/games': RiskLevel.LOW,
  'GET https://games.roblox.com/v2/groups/{groupId}/gamesV2': RiskLevel.LOW,
  'GET https://games.roblox.com/v2/users/{userId}/favorite/games': RiskLevel.LOW,
  'GET https://games.roblox.com/v2/users/{userId}/games': RiskLevel.LOW,
  'DELETE https://groups.roblox.com/v1/featured-content/event': RiskLevel.MEDIUM,
  'GET https://groups.roblox.com/v1/featured-content/event': RiskLevel.LOW,
  'POST https://groups.roblox.com/v1/featured-content/event': RiskLevel.MEDIUM,
  'GET https://groups.roblox.com/v1/groups/{groupId}': RiskLevel.LOW,
  'GET https://groups.roblox.com/v1/groups/{groupId}/audit-log': RiskLevel.CRITICAL,
  'POST https://groups.roblox.com/v1/groups/{groupId}/change-owner': RiskLevel.CRITICAL,
  'POST https://groups.roblox.com/v1/groups/{groupId}/claim-ownership': RiskLevel.CRITICAL,
  'PATCH https://groups.roblox.com/v1/groups/{groupId}/description': RiskLevel.MEDIUM,
  'DELETE https://groups.roblox.com/v1/groups/{groupId}/join-requests': RiskLevel.MEDIUM,
  'GET https://groups.roblox.com/v1/groups/{groupId}/join-requests': RiskLevel.MEDIUM,
  'POST https://groups.roblox.com/v1/groups/{groupId}/join-requests': RiskLevel.HIGH,
  'DELETE https://groups.roblox.com/v1/groups/{groupId}/join-requests/users/{userId}':
    RiskLevel.MEDIUM,
  'GET https://groups.roblox.com/v1/groups/{groupId}/join-requests/users/{userId}':
    RiskLevel.MEDIUM,
  'POST https://groups.roblox.com/v1/groups/{groupId}/join-requests/users/{userId}':
    RiskLevel.MEDIUM,
  'GET https://groups.roblox.com/v1/groups/{groupId}/membership': RiskLevel.MEDIUM,
  'PATCH https://groups.roblox.com/v1/groups/{groupId}/name': RiskLevel.CRITICAL,
  'GET https://groups.roblox.com/v1/groups/{groupId}/name-history': RiskLevel.LOW,
  'PATCH https://groups.roblox.com/v1/groups/{groupId}/notification-preference': RiskLevel.MEDIUM,
  'GET https://groups.roblox.com/v1/groups/{groupId}/payout-restriction': RiskLevel.MEDIUM,
  'GET https://groups.roblox.com/v1/groups/{groupId}/payouts': RiskLevel.HIGH,
  'POST https://groups.roblox.com/v1/groups/{groupId}/payouts': RiskLevel.CRITICAL,
  'POST https://groups.roblox.com/v1/groups/{groupId}/payouts/recurring': RiskLevel.CRITICAL,
  'GET https://groups.roblox.com/v1/groups/{groupId}/relationships/{groupRelationshipType}':
    RiskLevel.LOW,
  'DELETE https://groups.roblox.com/v1/groups/{groupId}/relationships/{groupRelationshipType}/{relatedGroupId}':
    RiskLevel.MEDIUM,
  'POST https://groups.roblox.com/v1/groups/{groupId}/relationships/{groupRelationshipType}/{relatedGroupId}':
    RiskLevel.MEDIUM,
  'DELETE https://groups.roblox.com/v1/groups/{groupId}/relationships/{groupRelationshipType}/requests':
    RiskLevel.MEDIUM,
  'GET https://groups.roblox.com/v1/groups/{groupId}/relationships/{groupRelationshipType}/requests':
    RiskLevel.MEDIUM,
  'POST https://groups.roblox.com/v1/groups/{groupId}/relationships/{groupRelationshipType}/requests':
    RiskLevel.MEDIUM,
  'DELETE https://groups.roblox.com/v1/groups/{groupId}/relationships/{groupRelationshipType}/requests/{relatedGroupId}':
    RiskLevel.MEDIUM,
  'POST https://groups.roblox.com/v1/groups/{groupId}/relationships/{groupRelationshipType}/requests/{relatedGroupId}':
    RiskLevel.MEDIUM,
  'GET https://groups.roblox.com/v1/groups/{groupId}/roles': RiskLevel.LOW,
  'GET https://groups.roblox.com/v1/groups/{groupId}/roles/{roleSetId}/permissions':
    RiskLevel.MEDIUM,
  'PATCH https://groups.roblox.com/v1/groups/{groupId}/roles/{roleSetId}/permissions':
    RiskLevel.CRITICAL,
  'GET https://groups.roblox.com/v1/groups/{groupId}/roles/{roleSetId}/users': RiskLevel.LOW,
  'GET https://groups.roblox.com/v1/groups/{groupId}/roles/guest/permissions': RiskLevel.LOW,
  'GET https://groups.roblox.com/v1/groups/{groupId}/roles/permissions': RiskLevel.MEDIUM,
  'DELETE https://groups.roblox.com/v1/groups/{groupId}/rolesets/{rolesetId}': RiskLevel.HIGH,
  'PATCH https://groups.roblox.com/v1/groups/{groupId}/rolesets/{rolesetId}': RiskLevel.HIGH,
  'POST https://groups.roblox.com/v1/groups/{groupId}/rolesets/create': RiskLevel.CRITICAL,
  'GET https://groups.roblox.com/v1/groups/{groupId}/settings': RiskLevel.HIGH,
  'PATCH https://groups.roblox.com/v1/groups/{groupId}/settings': RiskLevel.CRITICAL,
  'GET https://groups.roblox.com/v1/groups/{groupId}/social-links': RiskLevel.LOW,
  'POST https://groups.roblox.com/v1/groups/{groupId}/social-links': RiskLevel.MEDIUM,
  'DELETE https://groups.roblox.com/v1/groups/{groupId}/social-links/{socialLinkId}':
    RiskLevel.MEDIUM,
  'PATCH https://groups.roblox.com/v1/groups/{groupId}/social-links/{socialLinkId}':
    RiskLevel.MEDIUM,
  'PATCH https://groups.roblox.com/v1/groups/{groupId}/status': RiskLevel.MEDIUM,
  'GET https://groups.roblox.com/v1/groups/{groupId}/users': RiskLevel.LOW,
  'POST https://groups.roblox.com/v1/groups/{groupId}/users': RiskLevel.MEDIUM,
  'DELETE https://groups.roblox.com/v1/groups/{groupId}/users/{userId}': RiskLevel.HIGH,
  'PATCH https://groups.roblox.com/v1/groups/{groupId}/users/{userId}': RiskLevel.HIGH,
  'GET https://groups.roblox.com/v1/groups/{groupId}/users/{userId}/permissions': RiskLevel.HIGH,
  'GET https://groups.roblox.com/v1/groups/{groupId}/wall/posts': RiskLevel.LOW,
  'POST https://groups.roblox.com/v1/groups/{groupId}/wall/posts': RiskLevel.MEDIUM,
  'DELETE https://groups.roblox.com/v1/groups/{groupId}/wall/posts/{postId}': RiskLevel.HIGH,
  'POST https://groups.roblox.com/v1/groups/{groupId}/wall/subscribe': RiskLevel.MEDIUM,
  'DELETE https://groups.roblox.com/v1/groups/{groupId}/wall/users/{userId}/posts': RiskLevel.HIGH,
  'GET https://groups.roblox.com/v1/groups/configuration/metadata': RiskLevel.LOW,
  'POST https://groups.roblox.com/v1/groups/create': RiskLevel.CRITICAL,
  'PATCH https://groups.roblox.com/v1/groups/icon': RiskLevel.HIGH,
  'GET https://groups.roblox.com/v1/groups/metadata': RiskLevel.LOW,
  'POST https://groups.roblox.com/v1/groups/policies': RiskLevel.LOW,
  'GET https://groups.roblox.com/v1/groups/search': RiskLevel.LOW,
  'GET https://groups.roblox.com/v1/groups/search/lookup': RiskLevel.LOW,
  'GET https://groups.roblox.com/v1/groups/search/metadata': RiskLevel.LOW,
  'GET https://groups.roblox.com/v1/roles': RiskLevel.LOW,
  'GET https://groups.roblox.com/v1/user/groups/pending': RiskLevel.MEDIUM,
  'DELETE https://groups.roblox.com/v1/user/groups/primary': RiskLevel.LOW,
  'POST https://groups.roblox.com/v1/user/groups/primary': RiskLevel.LOW,
  'GET https://groups.roblox.com/v1/users/{userId}/friends/groups/roles': RiskLevel.LOW,
  'GET https://groups.roblox.com/v1/users/{userId}/groups/primary/role': RiskLevel.LOW,
  'GET https://groups.roblox.com/v1/users/{userId}/groups/roles': RiskLevel.LOW,
  'GET https://groups.roblox.com/v1/groups/{groupId}/bans': RiskLevel.MEDIUM,
  'GET https://groups.roblox.com/v1/groups/{groupId}/bans/{userId}': RiskLevel.MEDIUM,
  'POST https://groups.roblox.com/v1/groups/{groupId}/bans/{userId}': RiskLevel.CRITICAL,
  'DELETE https://groups.roblox.com/v1/groups/{groupId}/bans/{userId}': RiskLevel.CRITICAL,
  'GET https://groups.roblox.com/v1/groups/{groupId}/blocked-keywords': RiskLevel.MEDIUM,
  'POST https://groups.roblox.com/v1/groups/{groupId}/blocked-keywords': RiskLevel.HIGH,
  'PATCH https://groups.roblox.com/v1/groups/{groupId}/blocked-keywords/{keywordId}':
    RiskLevel.HIGH,
  'DELETE https://groups.roblox.com/v1/groups/{groupId}/blocked-keywords/{keywordId}':
    RiskLevel.HIGH,
  'GET https://groups.roblox.com/v1/groups/{groupId}/emotes': RiskLevel.LOW,
  'GET https://groups.roblox.com/v2/groups': RiskLevel.LOW,
  'GET https://groups.roblox.com/v2/groups/{groupId}/experiences': RiskLevel.LOW,
  'GET https://groups.roblox.com/v2/users/{userId}/groups/roles': RiskLevel.LOW,
  'GET https://groups.roblox.com/v2/groups/{groupId}/wall/posts': RiskLevel.LOW,
  'POST https://groups.roblox.com/v2/groups/{groupId}/wall/posts': RiskLevel.MEDIUM,
  'DELETE https://inventory.roblox.com/v1/collections/items/{itemType}/{itemTargetId}':
    RiskLevel.MEDIUM,
  'POST https://inventory.roblox.com/v1/collections/items/{itemType}/{itemTargetId}':
    RiskLevel.MEDIUM,
  'GET https://inventory.roblox.com/v1/packages/{packageId}/assets': RiskLevel.LOW,
  'GET https://inventory.roblox.com/v1/users/{userId}/assets/collectibles': RiskLevel.LOW,
  'GET https://inventory.roblox.com/v1/users/{userId}/can-view-inventory': RiskLevel.LOW,
  'GET https://inventory.roblox.com/v1/users/{userId}/categories': RiskLevel.LOW,
  'GET https://inventory.roblox.com/v1/users/{userId}/categories/favorites': RiskLevel.LOW,
  'GET https://inventory.roblox.com/v1/users/{userId}/items/{itemType}/{itemTargetId}':
    RiskLevel.LOW,
  'GET https://inventory.roblox.com/v1/users/{userId}/items/{itemType}/{itemTargetId}/is-owned':
    RiskLevel.LOW,
  'GET https://inventory.roblox.com/v1/users/{userId}/places/inventory': RiskLevel.LOW,
  'GET https://inventory.roblox.com/v2/assets/{assetId}/owners': RiskLevel.LOW,
  'DELETE https://inventory.roblox.com/v2/inventory/asset/{assetId}': RiskLevel.HIGH,
  'GET https://inventory.roblox.com/v2/users/{userId}/inventory': RiskLevel.LOW,
  'GET https://inventory.roblox.com/v2/users/{userId}/inventory/{assetTypeId}': RiskLevel.LOW,
  'POST https://itemconfiguration.roblox.com/v1/creations/get-asset-details': RiskLevel.MEDIUM,
  'GET https://itemconfiguration.roblox.com/v1/creations/get-assets': RiskLevel.MEDIUM,
  'GET https://itemconfiguration.roblox.com/v1/item-tags': RiskLevel.LOW,
  'POST https://itemconfiguration.roblox.com/v1/item-tags': RiskLevel.MEDIUM,
  'DELETE https://itemconfiguration.roblox.com/v1/item-tags/{itemTagId}': RiskLevel.MEDIUM,
  'GET https://itemconfiguration.roblox.com/v1/item-tags/metadata': RiskLevel.LOW,
  'GET https://itemconfiguration.roblox.com/v1/tags': RiskLevel.LOW,
  'GET https://itemconfiguration.roblox.com/v1/tags/prefix-search': RiskLevel.LOW,
  'GET https://locale.roblox.com/v1/country-regions': RiskLevel.LOW,
  'GET https://locale.roblox.com/v1/locales': RiskLevel.LOW,
  'POST https://locale.roblox.com/v1/locales/set-show-roblox-translations': RiskLevel.MEDIUM,
  'POST https://locale.roblox.com/v1/locales/set-user-supported-locale': RiskLevel.MEDIUM,
  'GET https://locale.roblox.com/v1/locales/supported-locales': RiskLevel.LOW,
  'GET https://locale.roblox.com/v1/locales/supported-locales-for-creators': RiskLevel.LOW,
  'GET https://locale.roblox.com/v1/locales/user-locale': RiskLevel.MEDIUM,
  'GET https://locale.roblox.com/v1/locales/user-localization-locus-supported-locales':
    RiskLevel.MEDIUM,
  'POST https://localizationtables.roblox.com/v1/auto-localization-table/games/{gameId}/assets-generation-request':
    RiskLevel.MEDIUM,
  'POST https://localizationtables.roblox.com/v1/auto-localization-table/games/{gameId}/auto-scrape-cleanup-request':
    RiskLevel.MEDIUM,
  'PATCH https://localizationtables.roblox.com/v1/auto-localization-table/games/{gameId}/ingestion':
    RiskLevel.MEDIUM,
  'PATCH https://localizationtables.roblox.com/v1/autolocalization/games/{gameId}/autolocalizationtable':
    RiskLevel.HIGH,
  'POST https://localizationtables.roblox.com/v1/autolocalization/games/{gameId}/autolocalizationtable':
    RiskLevel.MEDIUM,
  'PATCH https://localizationtables.roblox.com/v1/autolocalization/games/{gameId}/settings':
    RiskLevel.MEDIUM,
  'GET https://localizationtables.roblox.com/v1/autolocalization/metadata': RiskLevel.LOW,
  'GET https://localizationtables.roblox.com/v1/localization-table/available-languages':
    RiskLevel.LOW,
  'GET https://localizationtables.roblox.com/v1/localization-table/limits': RiskLevel.LOW,
  'GET https://localizationtables.roblox.com/v1/localization-table/metadata': RiskLevel.LOW,
  'POST https://localizationtables.roblox.com/v1/localization-table/tables': RiskLevel.MEDIUM,
  'GET https://localizationtables.roblox.com/v1/localization-table/tables/{assetId}':
    RiskLevel.MEDIUM,
  'GET https://localizationtables.roblox.com/v1/localization-table/tables/{tableId}':
    RiskLevel.MEDIUM,
  'PATCH https://localizationtables.roblox.com/v1/localization-table/tables/{tableId}':
    RiskLevel.HIGH,
  'GET https://localizationtables.roblox.com/v1/localization-table/tables/{tableId}/entries':
    RiskLevel.MEDIUM,
  'POST https://localizationtables.roblox.com/v1/localization-table/tables/{tableId}/entries/translation-feedback':
    RiskLevel.MEDIUM,
  'POST https://localizationtables.roblox.com/v1/localization-table/tables/{tableId}/entries/translation-history':
    RiskLevel.MEDIUM,
  'GET https://localizationtables.roblox.com/v1/localization-table/tables/{tableId}/entry-count':
    RiskLevel.MEDIUM,
  'GET https://notifications.roblox.com/v2/push-notifications/chrome-manifest': RiskLevel.LOW,
  'POST https://notifications.roblox.com/v2/push-notifications/deregister-all-devices':
    RiskLevel.MEDIUM,
  'POST https://notifications.roblox.com/v2/push-notifications/deregister-current-device':
    RiskLevel.MEDIUM,
  'POST https://notifications.roblox.com/v2/push-notifications/deregister-current-device-ios-pushkit':
    RiskLevel.MEDIUM,
  'GET https://notifications.roblox.com/v2/push-notifications/get-current-device-destination':
    RiskLevel.MEDIUM,
  'GET https://notifications.roblox.com/v2/push-notifications/get-destinations': RiskLevel.MEDIUM,
  'GET https://notifications.roblox.com/v2/push-notifications/metadata': RiskLevel.MEDIUM,
  'POST https://notifications.roblox.com/v2/push-notifications/register-android-native':
    RiskLevel.MEDIUM,
  'POST https://notifications.roblox.com/v2/push-notifications/register-ios-native':
    RiskLevel.MEDIUM,
  'POST https://notifications.roblox.com/v2/push-notifications/register-ios-pushkit':
    RiskLevel.MEDIUM,
  'POST https://notifications.roblox.com/v2/stream-notifications/clear-unread': RiskLevel.MEDIUM,
  'GET https://notifications.roblox.com/v2/stream-notifications/get-latest-game-updates':
    RiskLevel.MEDIUM,
  'GET https://notifications.roblox.com/v2/stream-notifications/get-recent': RiskLevel.MEDIUM,
  'GET https://notifications.roblox.com/v2/stream-notifications/metadata': RiskLevel.LOW,
  'GET https://notifications.roblox.com/v2/stream-notifications/unread-count': RiskLevel.MEDIUM,
  'GET https://premiumfeatures.roblox.com/v1/users/{userId}/premium-upsell-precheck': RiskLevel.LOW,
  'GET https://premiumfeatures.roblox.com/v1/users/{userId}/validate-membership': RiskLevel.LOW,
  'POST https://presence.roblox.com/v1/presence/users': RiskLevel.MEDIUM,
  'GET https://privatemessages.roblox.com/v1/announcements': RiskLevel.MEDIUM,
  'GET https://privatemessages.roblox.com/v1/announcements/metadata': RiskLevel.MEDIUM,
  'GET https://privatemessages.roblox.com/v1/messages': RiskLevel.MEDIUM,
  'GET https://privatemessages.roblox.com/v1/messages/{messageId}': RiskLevel.MEDIUM,
  'POST https://privatemessages.roblox.com/v1/messages/archive': RiskLevel.MEDIUM,
  'POST https://privatemessages.roblox.com/v1/messages/mark-read': RiskLevel.MEDIUM,
  'POST https://privatemessages.roblox.com/v1/messages/mark-unread': RiskLevel.MEDIUM,
  'POST https://privatemessages.roblox.com/v1/messages/unarchive': RiskLevel.MEDIUM,
  'GET https://privatemessages.roblox.com/v1/messages/unread/count': RiskLevel.MEDIUM,
  'GET https://publish.roblox.com/v1/asset-quotas': RiskLevel.MEDIUM,
  'POST https://publish.roblox.com/v1/audio': RiskLevel.MEDIUM,
  'POST https://publish.roblox.com/v1/audio/verify': RiskLevel.MEDIUM,
  'POST https://publish.roblox.com/v1/badges/{badgeId}/icon': RiskLevel.MEDIUM,
  'POST https://publish.roblox.com/v1/games/{gameId}/thumbnail/image': RiskLevel.MEDIUM,
  'POST https://publish.roblox.com/v1/plugins/{pluginId}/icon': RiskLevel.MEDIUM,
  'GET https://thumbnails.roblox.com/v1/asset-thumbnail-animated': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/assets': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/assets-thumbnail-3d': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/badges/icons': RiskLevel.LOW,
  'POST https://thumbnails.roblox.com/v1/batch': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/bundles/thumbnails': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/developer-products/icons': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/game-passes': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/games/{universeId}/thumbnails': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/games/icons': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/games/multiget/thumbnails': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/groups/icons': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/places/gameicons': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/users/avatar': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/users/avatar-3d': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/users/avatar-bust': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/users/avatar-headshot': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/users/outfit-3d': RiskLevel.LOW,
  'GET https://thumbnails.roblox.com/v1/users/outfits': RiskLevel.LOW,
  'GET https://thumbnailsresizer.roblox.com/v1/resize/{hash}/{width}/{height}/{type}/{format}/{filterType}':
    RiskLevel.LOW,
  'GET https://thumbnailsresizer.roblox.com/v1/secureresize/{thumbPrint}/{hash}/{width}/{height}/{type}/{format}/{filterType}':
    RiskLevel.LOW,
  'GET https://trades.roblox.com/v1/trades/{tradeId}': RiskLevel.LOW,
  'POST https://trades.roblox.com/v1/trades/{tradeId}/decline': RiskLevel.HIGH,
  'GET https://trades.roblox.com/v1/trades/{tradeStatusType}': RiskLevel.LOW,
  'GET https://trades.roblox.com/v1/trades/{tradeStatusType}/count': RiskLevel.LOW,
  'POST https://trades.roblox.com/v1/trades/expire-outdated': RiskLevel.CRITICAL,
  'GET https://trades.roblox.com/v1/trades/metadata': RiskLevel.LOW,
  'GET https://trades.roblox.com/v1/users/{userId}/can-trade-with': RiskLevel.LOW,
  'GET https://trades.roblox.com/v2/trades/{tradeId}': RiskLevel.LOW,
  'GET https://trades.roblox.com/v2/users/{userId}/tradableItems': RiskLevel.LOW,
  'PATCH https://translationroles.roblox.com/v1/game-localization-roles/games/{gameId}':
    RiskLevel.HIGH,
  'GET https://translationroles.roblox.com/v1/game-localization-roles/games/{gameId}/current-user/roles':
    RiskLevel.MEDIUM,
  'GET https://translationroles.roblox.com/v1/game-localization-roles/games/{gameId}/roles/{role}/assignees':
    RiskLevel.MEDIUM,
  'GET https://translationroles.roblox.com/v1/game-localization-roles/roles/{role}/current-user':
    RiskLevel.MEDIUM,
  'GET https://twostepverification.roblox.com/v1/metadata': RiskLevel.MEDIUM,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/authenticator/verify':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/cross-device/retract':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/cross-device/retry':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/cross-device/verify':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/email/send-code':
    RiskLevel.HIGH,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/email/verify':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/passkey/verify-finish':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/passkey/verify-start':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/password/verify':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/recovery-codes/verify':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/security-key/verify-finish':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/security-key/verify-start':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/sms/send-code':
    RiskLevel.HIGH,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/challenges/sms/verify':
    RiskLevel.CRITICAL,
  'GET https://twostepverification.roblox.com/v1/users/{userId}/configuration': RiskLevel.HIGH,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/configuration/authenticator/disable':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/configuration/authenticator/enable':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/configuration/authenticator/enable-verify':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/configuration/email/disable':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/configuration/email/enable':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/configuration/security-key/disable':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/configuration/security-key/enable':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/configuration/security-key/enable-verify':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/configuration/security-key/list':
    RiskLevel.HIGH,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/configuration/sms/disable':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/configuration/sms/enable':
    RiskLevel.CRITICAL,
  'GET https://twostepverification.roblox.com/v1/users/{userId}/recovery-codes': RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/recovery-codes/clear':
    RiskLevel.CRITICAL,
  'POST https://twostepverification.roblox.com/v1/users/{userId}/recovery-codes/regenerate':
    RiskLevel.CRITICAL,
  'GET https://users.roblox.com/v1/birthdate': RiskLevel.HIGH,
  'POST https://users.roblox.com/v1/birthdate': RiskLevel.CRITICAL,
  'GET https://users.roblox.com/v1/description': RiskLevel.MEDIUM,
  'POST https://users.roblox.com/v1/description': RiskLevel.MEDIUM,
  'GET https://users.roblox.com/v1/display-names/validate': RiskLevel.LOW,
  'GET https://users.roblox.com/v1/gender': RiskLevel.HIGH,
  'POST https://users.roblox.com/v1/gender': RiskLevel.CRITICAL,
  'POST https://users.roblox.com/v1/usernames/users': RiskLevel.LOW,
  'POST https://users.roblox.com/v1/users': RiskLevel.LOW,
  'GET https://users.roblox.com/v1/users/{userId}': RiskLevel.LOW,
  'PATCH https://users.roblox.com/v1/users/{userId}/display-names': RiskLevel.MEDIUM,
  'GET https://users.roblox.com/v1/users/{userId}/display-names/validate': RiskLevel.MEDIUM,
  'GET https://users.roblox.com/v1/users/{userId}/username-history': RiskLevel.LOW,
  'GET https://users.roblox.com/v1/users/authenticated': RiskLevel.MEDIUM,
  'GET https://users.roblox.com/v1/users/authenticated/age-bracket': RiskLevel.MEDIUM,
  'GET https://users.roblox.com/v1/users/authenticated/country-code': RiskLevel.MEDIUM,
  'GET https://users.roblox.com/v1/users/authenticated/roles': RiskLevel.MEDIUM,
  'GET https://users.roblox.com/v1/users/search': RiskLevel.LOW,
} as const;

/**
 * Get the risk level for a specific endpoint
 * @param method HTTP method (GET, POST, etc.)
 * @param serverUrl Full server URL
 * @param path API path
 * @returns Risk level or CRITICAL as safe default
 */
export const getEndpointRiskLevel = (
  method: string,
  serverUrl: string,
  path: string,
): RiskLevel => {
  const key = `${method.toUpperCase()} ${serverUrl}${path}`;
  return (
    LEGACY_ENDPOINT_RISK_LEVELS[key as keyof typeof LEGACY_ENDPOINT_RISK_LEVELS] ||
    RiskLevel.CRITICAL
  );
};
